<template>
  <v-col>
    <v-row no-gutters v-for="(it, index) in mapVal" :key="getKey(it,index)">
      <p
        v-if="
          !mapKey[index].startsWith('id_') &&
            mapKey[index] != 'gid' &&
            mapKey[index] != 'id' &&
            mapKey[index] != 'createdAt' &&
            mapKey[index] != 'updatedAt'
        "
        class="p-row"
      >
        {{ capitalizeFirst(mapKey[index]) }}:
        {{ formatItem(mapKey[index], mapVal[index]) }}
      </p>
    </v-row>
  </v-col>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      detailItem: {},
      mapKey: [],
      mapVal: [],
      name: this.$route.params.name,
    };
  },
  mounted() {
    this.getItem();
    this.mapKey = Object.keys(this.detailItem);
    this.mapVal = Object.values(this.detailItem);
  },
  props: {
    headers: Array,
    item: Object,
  },
  methods: {
    getKey(it,ind){
      return Math.random()
    },
    getName() {
      if(this.name == undefined) return null;
      else return this.name
    },
    getItem() {
      var item = this.item;
      this.detailItem = item;
    },
    parseFecha(fecha) {
      var m = new Date(fecha);
      var hh = m.getHours();
      var mins = m.getMinutes();
      var secs = m.getSeconds();
      var hourtime = [
          (hh > 9 ? "" : "0") + hh,
          (mins > 9 ? "" : "0") + mins,
          (secs > 9 ? "" : "0") + secs
        ].join(":");
      var nf =
        ("0" + m.getUTCDate()).slice(-2) +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        m.getUTCFullYear() +
        " " + hourtime;
      return nf;
    },
    capitalizeFirst(str) {
      var c = str.charAt(0).toUpperCase() + str.slice(1);
      var final = c;
      if (c.includes("_")) {
        final = c.split("_")[0] + " " + c.split("_")[1];
      }
      return this.formatKeys(final);
    },
    formatKeys(final) {
      if (final == "Role") return "Rol";
      else if (final == "Name") return "Nombre";
      else if (final == "Username") return "Nombre de Usuario";
      else return final;
    },
    formatItem(key, value) {
      if (key == "fecha") {
        return this.parseFecha(value);
      } else if (key == "id" || key == "gid") {
        return value;
      } else if (key == "user") {
        if (value != undefined && value != null) {
          return value.username;
        } else {
          return "Sin asignar";
        }
      } else if (key == "material") {
        if (value != undefined && value != null) {
          return value.nombre;
        } else {
          return "Sin asignar";
        }
      } else if (key == "proveedor" ) {
        return value.nombre;
      } else if(key == "planta" || key == "estanteria" || key == "balda" || key == "zona"){
        return value
      } else if (key == "ubicacion") {
        return value.id;
      } else if (key == "precio") {
        return value + "€";
      } else if (value == true) {
        return "Sí";
      } else if (value == false) {
        return "No";
      } else if (value == "" || value == undefined || value == null) {
        return "Sin determinar";
      } else if (Array.isArray(value)) {
        return value[value.length - 1];
      } else {
        return value;
      }
    }
  }
};
</script>
<style>
.p-row {
  width: fit-content;
  height: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/table/DetailRow.vue